const numbers = {};

// https://stackoverflow.com/questions/1458633/how-to-deal-with-floating-point-number-precision-in-javascript
numbers.strip = (number, precision) => parseFloat(number).toPrecision(precision);

export default numbers;
